export default class ObjectManager {
  constructor(createNew, onSelect) {
    this._createNew = createNew;
    this._onSelect = onSelect;
    this._objects = [];
    this._selectedIdx = 0;

    const self = this;
    const proxyTemplate = name => new Proxy({
      get current() {
        console.assert(0 <= self._selectedIdx && self._selectedIdx < self._objects.length);
        return self._objects[self._selectedIdx][name];
      },
    }, {
      apply: (target, thisArg, argumentsList) => {
        return target.current(...argumentsList);
      },
      construct: (target, argumentsList, newTarget) => {
        return new target.current(...argumentsList);
      },
      defineProperty: (target, p, attributes) => {
        target.current[p] = attributes.value;
      },
      deleteProperty: (target, p) => {
        delete target.current[p];
      },
      get: (target, p, receiver) => {
        return target.current[p];
      },
      getOwnPropertyDescriptor: (target, p) => {
        return Object.getOwnPropertyDescriptor(target.current, p);
      },
      has: (target, p) => {
        return p in target.current;
      },
      isExtensible: (target) => {
        return Object.isExtensible(target.current);
      },
      ownKeys: (target) => {
        return Object.keys(target.current);
      },
      preventExtensions: (target) => {
        Object.preventExtensions(target.current);
      },
      set: (target, p, newValue, receiver) => {
        target.current[p] = newValue;
        return true;
      },
      setPrototypeOf: (target, newProto) => {
        Object.setPrototypeOf(target.current, newProto);
      },
    });
    const imageDataManager = proxyTemplate('imageDataManager');
    const changeTracker = proxyTemplate('changeTracker');
    this._proxies = {imageDataManager, changeTracker};
  }
  getSelectedIdx() {
    return this._selectedIdx;
  }
  getObjectsLength() {
    return this._objects.length;
  }
  getImageDataManagerProxy() {
    return this._proxies.imageDataManager;
  }
  getChangeTrackerProxy() {
    return this._proxies.changeTracker;
  }
  getImageDataManager(idx) {
    return this._objects[idx].imageDataManager;
  }
  getChangeTracker(idx) {
    return this._objects[idx].changeTracker;
  }
  getCurrentImageDataManager() {
    return this._objects[this._selectedIdx].imageDataManager;
  }
  getChangeTrackers() {
    return this._objects.map(v => v.changeTracker);
  }
  select(idx) {
    this._selectedIdx = idx;
    this._onSelect();
  }
  add(idx, sz) {
    for(let i = 0; i < sz; ++i) {
      const obj = this._createNew();
      this._objects.splice(idx, 0, obj);
      obj.imageDataManager.addFrame(0, 1);
    }
  }
  duplicate(idx, sz) {
    const oldObjects = this._objects.slice();
    for(let i = 0; i < sz; ++i) {
      const obj = this._createNew();
      obj.imageDataManager.copy(oldObjects[idx + i].imageDataManager);
      this._objects.splice(idx, 0, obj);
    }
  }
  delete(idx, sz) {
    this._objects.splice(idx, sz);
  }
  move(srcIdx, srcSz, dstIdx) {
    const arrSrc = this._objects.slice(srcIdx, srcIdx + srcSz);
    this._objects.splice(dstIdx, 0, ...arrSrc);
    this.delete(srcIdx < dstIdx ? srcIdx : srcIdx + srcSz, srcSz);
  }
  save() {
    const ret = {
      objects: [],
    };
    for(const object of this._objects) {
      ret.objects.push({
        imageDataManager: object.imageDataManager.save(),
      });
    }
    return ret;
  }
  restore({objects}, isAdding = false) {
    if(!isAdding) this._objects = [];
    for(const objectData of objects) {
      const object = this._createNew();
      object.imageDataManager.restore(objectData.imageDataManager);
      this._objects.push(object);
    }
  }
  exportZIP(scale, onReady) {
    const worker = new Worker(new URL('workers/exportZIP.js', import.meta.url), {type: 'module'});
    const imageLists = [];
    for(let i = 0; i < this._objects.length; ++i) {
      imageLists.push(this._objects[i].imageDataManager.getImages());
    }
    worker.onmessage = e => {
      onReady(e.data);
    }
    worker.postMessage({imageLists, scale});
  }
}
